<template>
  <SidebarProjectRow
    :to="target_route"
    :is_active="is_active"
    :avatar_src="project.attributes.picture_login_url_s"
    :avatar_name="project.attributes.name"
    data_test="project-navbar-item"
    @click="emit('close')"
  />
</template>

<script setup>
import { computed } from 'vue';
import { ROUTES_PARTNERS } from '@/app/data/route_constants';
import SidebarProjectRow from '@/app/shared_components/sidebar/SidebarProjectRow.vue';

const props = defineProps({
  project: { type: Object, required: true },
  is_active: { type: Boolean, default: false },
});

const emit = defineEmits(['close']);

const target_route = computed(() => ({
  name: ROUTES_PARTNERS.PROJECT_INFORMATION,
  params: { project_id: props.project.id },
}));
</script>
